export const prettifyXml = (sourceXml) => {
    const xmlDoc = new DOMParser().parseFromString(sourceXml, 'application/xml');
    const xsltDoc = new DOMParser().parseFromString([
        // describes how we want to modify the XML - indent everything
        '<xsl:stylesheet xmlns:xsl="http://www.w3.org/1999/XSL/Transform">',
        '  <xsl:strip-space elements="*"/>',
        '  <xsl:template match="para[content-style][not(text())]">', // change to just text() to strip space in text nodes
        '    <xsl:value-of select="normalize-space(.)"/>',
        '  </xsl:template>',
        '  <xsl:template match="node()|@*">',
        '    <xsl:copy><xsl:apply-templates select="node()|@*"/></xsl:copy>',
        '  </xsl:template>',
        '  <xsl:output indent="yes"/>',
        '</xsl:stylesheet>',
    ].join('\n'), 'application/xml');

    const xsltProcessor = new XSLTProcessor();
    xsltProcessor.importStylesheet(xsltDoc);
    const resultDoc = xsltProcessor.transformToDocument(xmlDoc);
    return new XMLSerializer().serializeToString(resultDoc);
};

export const prettifyJson = (sourceJson) => {
    return JSON.stringify(sourceJson, null, 4);
}

export const prettyPrint = (xmlOrJson) => {
    if (!xmlOrJson) {
        return null;
    }
    return typeof xmlOrJson === 'string' ?
        (xmlOrJson.includes('<?xml') ? prettifyXml(xmlOrJson) : xmlOrJson)
        : prettifyJson(xmlOrJson);
};

export const isEmpty = (obj) => {
    return Object.keys(obj).length === 0;
};

export const formatTimestamp = (timestampString) => {
    const date = new Date(Date.parse(timestampString));
    return date.toLocaleTimeString('FI');
};
